import { apiRequest } from './apiClient';
import type { ApiAction, ActionContract } from '../model/actions';
import { mapApiActionsToContracts } from '../model/actions';
import fallbackActions from '../../docs/Actions.json';

export const getActions = async (): Promise<ActionContract[]> => {
  try {
    const apiActions = await apiRequest<ApiAction[]>('/actions');
    return mapApiActionsToContracts(apiActions);
  } catch {
    // Fallback to bundled action definitions when API is unavailable
    return mapApiActionsToContracts(fallbackActions as ApiAction[]);
  }
};
